export default __webpack_public_path__ + "e5e213a5f0a6fe314476a49e97c1f31c.png";